import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './PdfModal.module.scss';
import Modal, { ModalProps } from '../Modal';

export type PdfModalProps = Omit<ModalProps, 'title' | 'btnClose' | 'close' | 'isVisible'> & {
  url: string;
};

export type OpenShareModalType = PdfModalProps & {
  resolve: (value: any) => void;
  reject: (reason?: any) => void;
};

export type OpenShareModalListenerType = (args: OpenShareModalType) => void;

let listener: OpenShareModalListenerType | null = null;

const setListener = (callback: OpenShareModalListenerType) => {
  listener = callback;
  return removeListener;
};

const removeListener = () => {
  listener = null;
};

export const openPdfModal = ({ cssClass, url }: PdfModalProps) =>
  new Promise<void>((resolve, reject) => {
    listener &&
      listener({
        url,
        cssClass,
        resolve,
        reject,
      });
  });

const PdfModal: React.FC = () => {
  const [t] = useTranslation();
  const [cssClass, setCssClass] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [closeModal, setCloseModal] = useState<any>(() => {});

  const onUnMount = setListener(async ({ url, cssClass }: OpenShareModalType) => {
    setIsVisible(true);
    setCssClass(cssClass || null);
    setPdfUrl(url);
    const close = () => {
      setIsVisible(false);
    };
    setCloseModal(() => close);
  });

  useEffect(() => {
    return () => {
      onUnMount();
    };
  }, [onUnMount]);

  const onDownload = () => {
    if (!pdfUrl) return;
    // open the pdf in a new tab
    window.open(pdfUrl, '_blank');

    closeModal();
  };

  return (
    <Modal title={''} btnClose={t('CLOSE')} isVisible={isVisible} cssClass={styles.ff_pdf_modal__modal_override} close={closeModal}>
      <div data-testid='pdf-modal' className={styles.ff_pdf_modal__content}>
        <div className={styles.ff_pdf_modal__content_headline}>
          <span>The PDF preview is ready.</span>
        </div>
        <div className={styles.ff_pdf_modal__content_description}>
          <h4>In case the PDF is of low resolution, please go back to the editor, zoom in and try again.</h4>
        </div>
        <div className={styles.ff_pdf_modal__footer}>
          <button onClick={onDownload}>Download</button>
        </div>
      </div>
    </Modal>
  );
};

export default PdfModal;
